import { Component, OnInit, Injector, ViewChild, ElementRef, EventEmitter, Output } from "@angular/core";
import { AChartComponent } from "../achart/achart.component";
import { dragAndDropSymbol } from "../../services/dragAndDropSymbol/dragAndDropSymbol.service";
import { spaceAfterDataService } from "../../services/spaceAfterDataService/spaceAfterData.service";
import { ChartButtonsVisibleService } from "../../services/ChartButtonsVisible.service";
import { ShowChartTooltipService } from "../../services/ShoChartTooltip.service";
import { MobileMainView } from "../../enums/mobile-mainViews";
import { DisplayModeParams, ChartDisplayMode } from "../../enums/ChartDisplayMode.list";
import { getPeriodName, historyPeriods } from "../../interfaces/historyItem";
import { StockSeriesType } from "../achart/achart.annotation.tools";
import { version } from "punycode";
import { ShowMobileColorPicker } from "../modals/mobile-chart-options-modal/show-mobile-color-picker";
import {chartLinesService} from "../../services/chartLinesService";

@Component({
    selector: "mobile-achart",
    template: require('./mobile-achart.component.html'),
    styles: [require('../achart/achart.component.css'), require('../mobile-achart/mobile-achart.component.css')]
})
export class MobileAchartComponent extends AChartComponent implements OnInit {
    // @ViewChild("mobileChartTopPanel")
    // mobileChartTopPanel?: ElementRef;

    @Output("onSelectAction")
    change: EventEmitter<string> = new EventEmitter<string>();

    constructor(
        injector: Injector,
        private _dragAndDropSymbol: dragAndDropSymbol,
        private __showSpaceAfterDataService: spaceAfterDataService,
        private _chartButtonsVisibleService: ChartButtonsVisibleService,
        private _showChartTooltipService: ShowChartTooltipService,
        private _tradeLinesVisibilityService:chartLinesService
    ) {
        super(
            injector,
            _dragAndDropSymbol,
            __showSpaceAfterDataService,
            _chartButtonsVisibleService,
            _showChartTooltipService,
            _tradeLinesVisibilityService
        );


            this.dataService.dataSubscriber.subscribe(response => {
                if (response.ReqID === this._currentRequestId) {
                    if(response.Symbol!=this.currentSymbol)
                    {
                        this.onSelectNewSymbol(this.currentSymbol);
                    }
                }
                //if()
            })
        //  this.selectionRange = 50;
    }

    ngOnInit() {
        console.log("RUN MOBILE CHART");

        setTimeout(() => {
            this.runChart();
            this.refreshPeriod();
            this.updateChartDisplay(this.workspace.chartDisplayMode);

            this.detectHorizontalChange();

            this.chartDisplayModeService.subscriber.subscribe(currentDisplay => {
                // if(currentDisplay!=ChartDisplayMode.ENTSIGNALS)
                //{
                this.changeScalesVisibility();
                //  }
            });
        }, 1000);

        this.symbolTypeService.subscriber.subscribe(t => {
            //  console.log(this.workspaceService.data.activeBasket);
            if (this.workspace.activeBasket != -1) {
                this.filterBasketItemsByActiveBasket();
                // this.refreshSymbolAfterChanges();
            } else {
                this.boxes = this.workspace.getSymbolsTypeSlit(t);
            }
            // this.refreshSymbolAfterChanges();
        });

        this.globaGridMode.changeActiveBasket.subscribe(x => {
            if (x != -1) {
                this.filterBasketItemsByActiveBasket();
            } else {
                this.boxes = this.workspace.getSymbolsTypeSlit(this.workspace.activeSymbolType);
            }
            //  this.refreshSymbolAfterChanges();
        });

        /**
         * "Year", "Month", "Day", "Hour", "Minute", "Second", "Millisecond".
         */
        // public visibleUnits:string = "Millisecond";

        // this.chart.selectRange(this.visibleUnits,this.numOfVisibleUnits, "LastDate", true);
    }

    public detectHorizontalChange() {
        setTimeout(() => {
            if (this.prevIsHorizontalMode != this.workspace.horizontalMode) {
                if (this.itemID == "ach1" && !this.entryDisplay) {
                    this.selectionRangeUpdate();
                    console.log("TChange");
                }

                this.changeScalesVisibility();
                this.prevIsHorizontalMode = this.workspace.horizontalMode;
            }

            this.detectHorizontalChange();
        }, 100);
    }

    public changeScalesVisibility() {
        if (this.chart != undefined) {
            console.log(this.chart);
            setTimeout(() => {
                if (this.entryDisplay) {
                   
                    if (this.workspace.entrySignalsMultipleCharts) {
                        console.log("HIDE SELECTIOB");
                        this.chart.scroller().enabled(false);
                        
                        this.chart
                            .plot(0)
                            .yAxis()
                            .enabled(false);
                     
                        var padding = this.chart.padding();
                        console.log(padding);
                        this.chart.padding().right(0);
                     
                    } else {
                        console.log("SHOW SELECTIOB");
                        this.chart.scroller().enabled(true);
                        this.chart
                            .plot(0)
                            .yAxis()
                            .enabled(true);
                      
                        this.chart.padding().right(55);
                        this.chart.padding().left(1);
                    }
                } else {
                    this.chart.scroller().enabled(true);
                    this.chart
                        .plot(0)
                        .yAxis()
                        .enabled(true);
                    //  this.chart.plot(2).yAxis().enabled(true)
                    this.chart.padding().right(55);
                    this.chart.padding().left(5);
                }
            }, 500);
        }
    }

    chartdDisplayModeList: object = DisplayModeParams();

    get AChartComponent() {
        return this;
    }

    public showChartMenu() {
        const chart = this.workspace.charts["ach1"].instance;
        if (chart) chart.showContextmenu(null as any);
    }

    private _showMenuAction: string = "NO";
    public get showMenuAction(): string {
        return this._showMenuAction;
    }
    public set showMenuAction(value: string) {
        this._showMenuAction = value;
    }

    public showContextmenu(event: MouseEvent) {

        if(this.entryDisplay)
        {
         //   return false;;
        }

        this.showMenuAction = "STEP_1";


        if ((this.activeDisplayMode == ChartDisplayMode.WIZARD && this.Config.wizardshowResistanceLines) ||
            (this.activeDisplayMode == ChartDisplayMode.CHARTING && this.Config.chartingshowResistanceLines)) {

            if (event != null && this.getClickedSupportLine({ x: event.clientX, y: event.clientY }) != null) {
                this.showMenuAction += "STEP_2";

                ShowMobileColorPicker(
                    this.modalService,
                    this.SupportLinesColor,
                    "Pick Support & Resistance lines color"
                ).then(color => this.colorPicked(color));
                return false;
            }
        }


        return super.showContextmenu(event);
    }

    public backAction() {
        this.workspace.mobileView = MobileMainView.PANEL;
        this.change.emit(this.itemID);
    }

    public changeActiveDisplayMode(v: any) {
        console.log('change display mode', v);
        this.workspace.chartDisplayMode = v;
    }

    wqFix() {
        return {
            paddingBottom: "60px"
        };
    }

    public setActiveSymbol(v: any) {
        this.symbol = v;
    }

    public get periods(): {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[] {
        return this.workspace.periodsList;
    }

    public set periods(value: {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[]) {
        this.workspace.periodsList = value;
    }

    public setActivePeriod(e: any) {
        this.period = e;
    }

    //get

    public seriesTypes: { id: string; label: string; image?: string }[] = [
        { id: StockSeriesType.CANDLESTICK, label: "Candlestick", image: "css/images/candlestick.png" },
        { id: StockSeriesType.LINE, label: "Line", image: "css/images/line-1.png" },
        { id: StockSeriesType.OHLC, label: "OHLC", image: "css/images/ohlc.png" },
        { id: StockSeriesType.PRICEPOINTLINE, label: "Price Points", image: "css/images/points.png" }
    ];

    public setActiveSeriesType(v: any) {
        this.chartSerieType = v;
    }

    public get activeDisplayMode() {
        return this.workspace.chartDisplayMode;
    }

    calculateChartContainerHeight() {
        let topBarHeight = 0; //this.mobileChartTopPanel!.nativeElement.offsetHeight
        return {
            height: `calc(100% - ${topBarHeight}px)`
        };
    }

    public get currentSymbol() {
        return this.item!.Symbol;
    }

    public get currentPeriod() {
        return getPeriodName(this.period);
    }

    public get currentSerieType() {
        return this.chartSerieType;
    }

    public get iconOfSerieType() {
        let i = this.seriesTypes.filter(v => {
            if (v.id == this.currentSerieType) {
                return v;
            }
        });

        if (i[0].image !== undefined) {
            return i[0].image;
        }

        return "";
    }

    public boxes: string[] = [];
    public symbolItems: { id: string; label: string }[] = [];
    public get currentSymbolList() {
        //this.workspace.activeSymbolType
        // this.boxes = this.workspace.getSymbolsTypeSlit(this.workspace.activeSymbolType);

        this.symbolItems = this.boxes.map(v => {
            let l: { id: string; label: string } = { id: String(v), label: String(v) };
            return l;
        });

        return this.symbolItems;
    }

    private filterBasketItemsByActiveBasket() {
        if (this.workspace.getActiveBasketItems() !== undefined) {
            let selected = this.workspace.getActiveBasketItems().filter(v => {
                let element = this.workspace.SymbolInfoes.filter(t => {
                    if (t.Symbol === v) {
                        return t.Type;
                    }
                });
                if (element[0].Type === this.workspace.activeSymbolType) {
                    return element[0].Symbol;
                }
            });

            this.boxes = selected;
            this.workspace.AppTick();
        }
    }

    private _showSelects: boolean = false;
    public get showSelects(): boolean {
        return this._showSelects;
    }
    public set showSelects(value: boolean) {
        this._showSelects = value;
    }

    selectionRangeUpdate() {
        let ranges = this.chart.getSelectedRange();

        if (this.HorizontalMode == true) {
            this.selectionRange = 100;
        } else {
            this.selectionRange = 50;
        }

        this.chart.selectRange(ranges.lastVisible - this.selectionRange * this._periodValue, ranges.lastVisible);
    }

    private _prevIsHorizontalMode: boolean = false;
    public get prevIsHorizontalMode(): boolean {
        return this._prevIsHorizontalMode;
    }
    public set prevIsHorizontalMode(value: boolean) {
        // if(!value)
        //    {

        //     }

        this._prevIsHorizontalMode = value;
    }

    public get HorizontalMode() {
        return this.workspace.horizontalMode;
    }

    increment() {
        this.change.emit(this.itemID);
    }
}
